module.exports = __webpack_public_path__ + "img/secure_icon.30d94e1f.svg";